export const availability = [
  "Metro Manila",
  "North Luzon",
  "South Luzon (Batangas City, Laguna and Bicol)",
  "Visayas",
  "Mindanao",
];
